import { render, staticRenderFns } from "./PatientTemperatureInput.vue?vue&type=template&id=5196fcd0&scoped=true&"
import script from "./PatientTemperatureInput.vue?vue&type=script&lang=js&"
export * from "./PatientTemperatureInput.vue?vue&type=script&lang=js&"
import style0 from "./PatientTemperatureInput.vue?vue&type=style&index=0&id=5196fcd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5196fcd0",
  null
  
)

export default component.exports